import { ClientResources, TranslationClient } from "@app/api2/api";
import { componentTypes, IComponent } from "@app/components";
import { EventBus, Validation } from ".";
import moment from "moment";
import * as ReactDOM from "react-dom";
import { setLocale } from "yup";
import { createRoot } from 'react-dom/client';

interface IElementComponent {
    element: Element;
    component: IComponent;
}

export class PageState {
    public bus: EventBus;
    public components: IElementComponent[];
    public validation: Validation;
    public translations: ClientResources;
    public locale: string;

    constructor(oldState: PageState) {
        this.loadLocalization().then(() => {
            window.pageState = this;
            this.bus = new EventBus();
            this.validation = new Validation();
            this.attachComponents(oldState);
            this.validation.attach();
            this.setLocalTimes();
            this.bus.subscribe("locale.changed",
                () => {
                    localStorage.removeItem("translation");
                    localStorage.removeItem("translation_timestamp");
                });
        });

    }

    public reactRender(element, container, callback): any {
        if (container instanceof jQuery) {
            container = container[0];
        }
        var root = createRoot(container);
        root.render(element);
        if (callback) {
            callback();
        }
        // return ReactDOM.render(element, container, callback);
    }

    private attachComponents(oldState: PageState) {
        this.components = new Array<IElementComponent>();
        const componentElements = document.querySelectorAll("[data-component]");

        componentElements.forEach((e) => {
            const names = e.getAttribute("data-component").split(" ");
            for (const n of names) {
                if (componentTypes[n]) {
                    this.createComponent(e, n, oldState);
                }
            }
        });
    }

    private setLocalTimes() {
        const timeElements = document.querySelectorAll("[data-time]");
        timeElements.forEach((t) => {
            const value = t.getAttribute("data-time");
            if (!value) {
                return;
            }
            const m = moment(value);
            m.locale(this.locale);
            t.innerHTML = m.format("l LTS");
        });
    }

    private createComponent(element: Element, componentType: string, oldState: PageState) {
        const c = componentTypes[componentType];
        const instance = new c() as IComponent;
        this.components.push({
            component: instance,
            element,
        });

        let state = null;
        if (oldState) {
            const oldComponent = oldState.components.find((e) => {
                return e.element === element;
            });

            if (oldComponent) {
                state = oldComponent.component.getState();
            }
        }

        instance.attach(element, this, state);
    }

    private async loadLocalization() {
        const cacheTimestamp = localStorage.getItem("translation_timestamp");
        const currentTimestamp = document.body.getAttribute("data-translation-timestamp");
        // console.log("translation cache timestamp", cacheTimestamp, "current timestamp", currentTimestamp);
        if (cacheTimestamp !== currentTimestamp) {
            const client = new TranslationClient();
            const locale = await client.getLocale();
            const translations = await client.getTranslation(locale.localeName);
            this.locale = locale.localeName;

            localStorage.setItem("locale", this.locale);
            localStorage.setItem("translation", JSON.stringify(translations));

            localStorage.setItem("translation_timestamp", currentTimestamp);
            this.translations = translations;
        } else {
            const translationSerialized = localStorage.getItem("translation");
            this.locale = localStorage.getItem("locale");
            this.translations = (JSON.parse(translationSerialized) as ClientResources);
        }        
        window.translation = this.translations;
        window.locale = this.locale;
        setLocale(this.translations.yup);
    }
}
